import ReactQuill from 'react-quill';
import { useEffect, useState, useRef } from 'react';
import './Editor.scss';
import 'react-quill/dist/quill.snow.css'; // Recommended
import { InputText } from "primereact/inputtext";
import { Button } from 'primereact/button';
import { getArticle, saveArticle, updateArticle, uploadThumbnail } from '../../service/article';
import { useUser } from '../../context/UserProvider';
import { Dropdown } from 'primereact/dropdown';


function ArticleEditor() {
    const [news, setNews] = useState({
        title: '',
        content: '',
        thumbnailUrl: null,
        category: 'NEWS',
        authorName: 'Ankur Tyagi',
        status: 'DRAFT',
    });
    const [mode, setMode] = useState('create'); // 'create' or 'edit'
    const { setErrorState } = useUser();

    const categoryOptions = [
        { label: 'News', value: 'NEWS' },
        { label: 'Politics', value: 'POLITICS' },
        { label: 'Sports', value: 'SPORTS' },
        { label: 'Entertainment', value: 'ENTERTAINMENT' },
        { label: 'Technology', value: 'TECHNOLOGY' },
        { label: 'Health', value: 'HEALTH' },
        { label: 'Business', value: 'BUSINESS' }];

    useEffect(() => {
        const queryParams = new URLSearchParams(window.location.search);
        const id = queryParams.get('id');
        if (id > 0) {
            setMode('edit');
            getArticle(id)
                .then(response => {
                    setNews({ ...response.data.data });
                })
                .catch(error => {
                    setErrorState("Failed to fetch article");
                });
        }
    }, []);

    const modules = {
        toolbar: {
            container: [
                [{ header: [1, 2, 3, false] }],
                ['bold', 'italic', 'underline', 'strike'],
                [{ color: [] }, { background: [] }],
                [{ script: 'sub' }, { script: 'super' }],
                [{ list: 'ordered' }, { list: 'bullet' }],
                [{ indent: '-1' }, { indent: '+1' }],
                [{ align: [] }],
                ['blockquote', 'code-block'],
                ['link', 'image', 'video'],
                ['clean'] // remove formatting
            ]
        },
        clipboard: {
            matchVisual: true // preserves line breaks
        },
        history: {
            delay: 2000,
            maxStack: 500,
            userOnly: true
        }
    };

    const handleCategoryChange = (e) => {
        setNews(prevContent => ({   
            ...prevContent,
            category: e.value   
        }
    ));}

    const handleChange = (e) => {
        const { name, value } = e.target;
        setNews(prevContent => ({
            ...prevContent,
            [name]: value
        }));
    };

    const handleBodyChange = (e) => {
        setNews(prevContent => ({
            ...prevContent,
            content: e
        }));
    }

    const resetForm = () => {
        setNews({
            title: '',
            content: ''
        });
    }

    const validateArticle = (article) => {
        if (article.title === null || article.title.trim() === '') {
            setErrorState("Title is required");
            return false;
        }
        if (article.content === null || article.content.trim() === '') {
            setErrorState("Content is required");
            return false;
        }
        console.log("File selected:", file);
        if (mode == 'create' && !file) {
            setErrorState("Thumbnail is required");
            return false;
        }
        if (article.category === null || article.category.trim() === '') {
            setErrorState("Category is required");
            return false;
        }
        return true;
    }

    const handleSubmit = async (e) => {
        let newsData = { ...news };
        try {
            e.preventDefault();
            if (!validateArticle(news)) return;
            var response;
            if (mode === 'create') {
                const uploadResponse = await uploadThumbnail(file);
                console.log("Upload Response:", uploadResponse.data);
                if (uploadResponse.status === 200) {
                    newsData.thumbnailUrl = uploadResponse.data;
                    response = await saveArticle(newsData);
                } else {
                    setErrorState("Failed to upload thumbnail");
                    return;
                }
            }
            if (mode === 'edit') {
                if (file) {
                    const uploadResponse = await uploadThumbnail(file);
                    if (uploadResponse.status === 200) {
                        newsData.thumbnailUrl = uploadResponse.data;
                    } else {
                        setErrorState("Failed to upload thumbnail");
                        return;
                    }
                }
                response = await updateArticle(newsData);
            }
            if (response.status === 200) {
                setErrorState("Article saved successfully");
                resetForm();
                window.location.href = '/admin';
            } else {
                setErrorState("Failed to save article");
            }
        } catch (error) {
            setErrorState("An error occurred while saving the article");
        }
    }

    const fileInputRef = useRef(null);
    const [filepath, setFilePath] = useState(null);
    const [file, setFile] = useState(null);

    const handleIconClick = () => {
        fileInputRef.current.click(); // 👉 triggers hidden input
    };

    const handleFileChange = (event) => {
        const selectedFile = event.target.files[0];
        setFilePath(URL.createObjectURL(selectedFile));

        if (!selectedFile) return;
        setFile(selectedFile);
    };

    return (
        <div className="admin-page">
            <form>

                <div style={{ marginTop: '20px' }}>
                    <InputText placeholder='Title' name='title' required id="title" value={news.title} onChange={handleChange} />
                </div>
                <div className='upload-thumbnail-wrapper'>
                    <input
                        type="file"
                        ref={fileInputRef}
                        style={{ display: "none" }}
                        onChange={handleFileChange}
                    />
                    <i className="pi pi-upload" onClick={handleIconClick} style={{ fontSize: '2rem' }}><span></span></i>
                </div>
                <img
                    height={150}
                    src={filepath || news.thumbnailUrl || "https://img.freepik.com/free-vector/news-grunge-text_460848-9369.jpg"}
                    alt="Thumbnail" id='thumbnail' />
                <div>
                    <label htmlFor="category">Category: &nbsp;</label>
                    <Dropdown id='category' value={news.category} onChange={handleCategoryChange} options={categoryOptions} optionLabel="label" optionValue="value"
                        placeholder="Select a category" className="w-full md:w-14rem" />
                </div>
                <div className="dark-quill-wrapper">
                    <ReactQuill name="content" placeholder='Edit News here...' value={news.content} onChange={handleBodyChange} modules={modules} theme="snow" />
                </div>
                <div>
                    {/* <Button variant="solid" color="primary" onClick={previewArticle} style={{ marginTop: '20px', marginRight: '10px' }}>
                        Preview
                    </Button> */}
                    <Button variant="solid" color="primary" onClick={handleSubmit} style={{ marginTop: '20px' }}>
                        Submit
                    </Button>
                </div>
            </form>
        </div>
    );
}

export default ArticleEditor;